module.exports = __webpack_public_path__ + "img/bb5594.7e4c2948.jpg";